import { Api } from 'Common/utils';

export function selectLanguage(language, setDefaultLanguage) {
    return Api.POST('/language/set', { language, setDefaultLanguage, url: window.location.pathname });
}
